// M&A Events export filters. Keys mirror hermes' MergersAcquisitionsFilters
// schema; covered-wagon converts them to snake_case.
import { NULL_POLICY, pruneFilterSections } from "./financingEvents";

export const MERGERS_ACQUISITIONS_CATEGORY_OPTIONS = [
  { value: "acquires", label: "Acquires" },
  { value: "merges_with", label: "Merges With" },
  { value: "spins_off_company", label: "Spins Off Company" },
  { value: "spins_off_division", label: "Spins Off Division" },
  { value: "splits_into", label: "Splits Into" },
];

export interface MergersAcquisitionsFilters {
  category?: {
    include?: string[];
    exclude?: string[];
  };
  effectiveDate?: {
    start?: string;
    end?: string;
    nullPolicy?: NULL_POLICY;
  };
  discoveredDate?: {
    start?: string;
    end?: string;
  };
}

export const DEFAULT_MERGERS_ACQUISITIONS_FILTERS: MergersAcquisitionsFilters =
  {};

export const pruneMergersAcquisitionsFilters = (
  filters: MergersAcquisitionsFilters
): MergersAcquisitionsFilters | undefined => pruneFilterSections(filters);
